<template>
  <div>
    <el-table :data="userList" style="width: 100%" height="calc(100vh - 360px)" @sort-change="handleSort">
      <!-- <el-table-column label="合伙人账户" fixed="left" width="180">
        <template slot-scope="scope">{{ scope.row.accountName }}</template>
</el-table-column> -->
      <el-table-column prop="tenantName" label="租户名称" align="center" />
      <el-table-column prop="remark" label="社区/备注" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="channelUserId" label="合伙人UID" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.channelUserId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="affairesId" label="商务ID" align="center" />

      <el-table-column prop="recharge" label="团队净入金" align="center" sortable="custom" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.recharge }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="email" label="邮箱" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.email }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tel" label="手机号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.tel }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rebateType" label="返佣模式" align="center">
        <template slot-scope="scope">
          <span>{{ rebatetTypeObj[scope.row.rebateType] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rebateCycle" label="返佣周期" align="center">
        <template slot-scope="scope">
          <span>{{ rebateCycleObj[scope.row.rebateCycle] || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="合约返佣比例（%）" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ BigNumber(scope.row.rate * 100).toNumber() | fixD(6) }}%</span>
        </template>
      </el-table-column>
      <el-table-column prop="spotRate" label="现货返佣比例（%）" align="center" width="120">
        <template slot-scope="scope">
          <span>{{ BigNumber(scope.row.spotRate * 100).toNumber() | fixD(6) }}%</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="otcRate" label="otc返佣比例（%）" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.otcRate?scope.row.otcRate*100: 0 }}%</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column prop="totalFee" label="用户合约手续费" align="center">
        <template slot-scope="scope">
          <span >{{ scope.row.totalFee }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="userNum" label="新增注册人数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.userNum }}</span>
         
        </template>
      </el-table-column>
      <el-table-column prop="txNumAdd" label="新增出金人数" align="center">
        <template slot-scope="scope">
          {{ scope.row.txNumAdd }}
        </template>
      </el-table-column>
      
      <el-table-column prop="rechargeNum" label="节点入金人数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.rechargeNum }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="txNum" label="节点出金人数" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.txNum }}</span>
        </template>
      </el-table-column>
     
      <el-table-column label="节点净充值总量" align="center">
        <template slot-scope="scope">{{
          scope.row.rechargeAmount
        }}</template>
      </el-table-column>
      <el-table-column label="节点出金总量" align="center">
        <template slot-scope="scope">
         {{ scope.row.txAmount }}
        
        </template>
      </el-table-column>
      <el-table-column label="开通合伙人时间" align="center" width="180">
        <template slot-scope="scope">
         {{ scope.row.createTime | moment }}
        
        </template>
      </el-table-column> -->
      <!-- <el-table-column  label="是否展示备注">
        <template slot-scope="scope">
          <span v-if="scope.row">{{ scope.row.type}}</span>
        </template>
      </el-table-column> -->

      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleUpdate(scope.row)">查看下级</el-button>
          <el-button size="mini" type="text" @click="handleNext(scope.row)">下级返佣记录</el-button>
          <!-- <el-button
            size="mini"
            type="text"
            @click="handleUpdatePartner(scope.row, 0)"
            v-if="scope.row.rebateRate == 0 && scope.row.type == 0"
            >升级合伙人</el-button
          >
           -->
          <el-button size="mini" type="text" @click="handleRate(scope.row, 1)">设置返佣比例</el-button>
          <el-button v-if="scope.row.inviteCode && !scope.row.inInviteChannelWhitelist" size="mini" type="text"
            @click="openInviteWhitelist(scope.row, false)">添加白名单</el-button>
          <el-button v-if="scope.row.inviteCode && scope.row.inInviteChannelWhitelist" size="mini" type="text"
            @click="openInviteWhitelist(scope.row, true)">编辑白名单</el-button>
          <el-button size="mini" type="text" @click="handlePsd(scope.row.channelUserId)">重置密码</el-button>
          <el-button size="mini" type="text" @click="handleLogin(scope.row)">{{
            scope.row.type == 1 ? '禁止登录' : '允许登录'
            }}</el-button>
          <el-button size="mini" type="text" @click="handleAddTopRemark(scope.row)">修改备注</el-button>
          <el-button size="mini" type="text" @click="handleAddUser(scope.row)">添加模拟用户</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="pageChanged">
      </pagination>
    </div>
    <!-- <update-dialog :val="userinfoDetail" :updateForm="updateForm"></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog title="修改备注" :visible.sync="centerDialogVisible" width="30%" center>
      <div class="main">
        <el-card class="box-card">
          <div>备注信息</div>
          <div class="content">
            <el-input type="textarea" :rows="5" placeholder="请输入备注信息" maxlength="50" show-word-limit v-model="remark">
            </el-input>
          </div>
          <div class="btn">
            <el-button size="small" type="primary" @click="add">添 加</el-button>
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <!-- 升级合伙人 -->
    <el-dialog :title="title" :visible.sync="partnerDialogVisible" width="30%" center>
      <div class="main">
        <el-card class="box-card box-card1">
          <div class="content">
            <el-form label-width="120px">
              <el-form-item label="返佣模式：" prop="rebateType">
                <el-select v-model="rebateType" placeholder="请选择" @change="handleRebateType">
                  <el-option v-for="item in rebateTypeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select> </el-form-item><el-form-item label="返佣周期：" prop="rebateCycle" v-if="rebateType !== 1">
                <el-select v-model="rebateCycle" placeholder="请选择">
                  <el-option v-for="item in rebateCycleList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合约返佣比例 :" v-if="rebateType !== 1">
                <el-input type="number" placeholder="请输入合约返佣比例" v-model="input2">
                  <template slot="append">%</template>
                </el-input>
                <div class="tip">
                  <span>
                    <i class="el-icon-warning-outline"></i>
                    说明:返佣比例一旦设定,只支持提高,不支持降低
                  </span>
                </div>
              </el-form-item>
              <el-form-item label="现货返佣比例 :" v-if="rebateType !== 1">
                <el-input type="number" placeholder="请输入现货返佣比例" v-model="spotRateInput">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn">
            <el-button size="small" @click="partnerDialogVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="addRate">确 定</el-button>
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <el-dialog :title="inviteWhitelistEdit ? '编辑白名单' : '添加白名单'" :visible.sync="inviteWhitelistVisible" width="520px"
      custom-class="invite-whitelist-dialog" append-to-body>
      <el-form v-if="inviteWhitelistRow" class="invite-whitelist-form" label-width="150px" size="small">
        <el-form-item label="邀请码">
          <el-input :value="inviteWhitelistRow.inviteCode" disabled />
        </el-form-item>
        <el-form-item label="合约返佣比例（%）">
          <el-input type="number" step="0.000001" v-model="wlContractPct" placeholder="须大于0，不超过合伙人合约比例" />
        </el-form-item>
        <el-form-item label="现货返佣比例（%）">
          <el-input type="number" step="0.000001" v-model="wlSpotPct" placeholder="须大于0，不超过合伙人现货比例" />
        </el-form-item>
      </el-form>
      <p style="color: #909399; font-size: 12px; line-height: 1.5; margin: 0 0 12px">
        设为白名单后，所邀请的新用户自动升级为二级合伙人且拥有此次设置的返佣比例。
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="inviteWhitelistVisible = false">取 消</el-button>
        <el-button v-if="inviteWhitelistEdit" size="small" type="danger"
          @click="handleRemoveInviteWhitelist">移除白名单</el-button>
        <el-button size="small" type="primary" @click="confirmInviteWhitelist">确 定</el-button>
      </div>
    </el-dialog>
    <AddUserDialog :id="id" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import AddUserDialog from '../addUserDialog'
import BigNumber from 'bignumber.js'
import api from '../../api'
import {
  REBATE_TYPE,
  REBATE_TYPE_OBJ,
  REBATE_CYCLE,
  REBATE_CYCLE_OBJ,
} from '../../constants'

export default {
  name: 'partnerList',
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      remark: '',
      centerDialogVisible: false,
      partnerDialogVisible: false,
      input2: '',
      spotRateInput: '',
      upgradeRateForm: {},
      title: '',
      channelUserId: '',
      rebateTypeList: REBATE_TYPE,
      rebatetTypeObj: REBATE_TYPE_OBJ,
      // rebateCycleList: REBATE_CYCLE,
      rebateCycleObj: REBATE_CYCLE_OBJ,
      rebateType: '',
      rebateCycle: '',
      id: '',
      inviteWhitelistVisible: false,
      inviteWhitelistEdit: false,
      inviteWhitelistRow: null,
      wlContractPct: '',
      wlSpotPct: '',
    }
  },
  components: {
    Pagination,
    updateDialog,
    AddUserDialog,
  },
  watch: {
    // rebateType(val, oldVal) {
    //   if (val === 3 && this.rebateCycle === 1) {
    //     this.rebateCycle = ''
    //   }
    // },
  },
  methods: {
    ...mapActions('partnerList', ['addTopRemark']),
    ...mapActions('partnerList', [
      'upgradePartner',
      'upgradeRate',
      'updatePsd',
      'forbidden',
    ]),
    ...mapMutations('partnerList', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
      'setOrderBy',
      'setAddUser',
    ]),
    add() {
      this.addTopRemark({
        topUserId: this.channelUserId,
        remark: this.remark,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
            ; (this.remark = ''), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
      })
    },
    addRate() {
      if (this.btnType == 0) {
        const params = {
          channelId: this.userInfo.channelId,
          userId: this.upgradeRateForm.id,
          rate: Number(this.input2),
        }
        if (
          this.spotRateInput !== '' &&
          this.spotRateInput !== null &&
          this.spotRateInput !== undefined
        ) {
          params.spotRate = Number(this.spotRateInput)
        }
        this.upgradePartner(params).then((res) => {
          if (res.code == 0) {
            this.$message.success('申请合伙人成功')
            this.partnerDialogVisible = false
            this.input2 = ''
            this.spotRateInput = ''
            this.$emit('refresh')
          } else {
            this.$message.error(res.error.msg)
          }
        })
      }
      if (this.btnType == 1) {
        const params = {
          userId: this.upgradeRateForm.channelUserId,
          rate: Number(this.input2),
          rebateType: this.rebateType,
          rebateCycle: this.rebateCycle,
        }
        if (
          this.spotRateInput !== '' &&
          this.spotRateInput !== null &&
          this.spotRateInput !== undefined
        ) {
          params.spotRate = Number(this.spotRateInput)
        }
        this.upgradeRate(params).then((res) => {
          if (res.code == 0 && res.data.code != -1) {
            this.$message.success('设置返佣比例成功')
            this.partnerDialogVisible = false
            this.input2 = ''
            this.spotRateInput = ''
            this.rebateType = ''
            this.rebateCycle = ''
            this.$emit('refresh')
          } else {
            this.$message.error(res.data.msg || res.error.msg)
          }
        })
      }
    },
    pageChanged(pagination) {
      this.$emit('refresh', { ...pagination })
    },
    handleUpdate(row) {
      this.updateForm = { ...row }
      this.$router.push({ path: '/home/friend', query: { ...row } })
      // this.setUserinfoDetail(selected);
      // this.setUserinfoDetailDialogVisible(true);

      // this.centerDialogVisible = true;
      // this.remark = row.remarks;
    },
    handleNext(row) {
      this.$router.push({ path: '/home/rebateList', query: { ...row } })
    },
    handleUpdatePartner(row, type) {
      this.title = '升级合伙人'
      this.upgradeRateForm = { ...row }
      this.partnerDialogVisible = true
      this.btnType = type
      this.spotRateInput =
        row.spotRate !== undefined && row.spotRate !== null
          ? BigNumber((row.spotRate * 10000) / 100).toNumber()
          : ''
    },
    handleRebateType(type) {
      if (type === 3 && this.rebateCycle === 1) {
        this.rebateCycle = 2
      }
    },
    handleRate(row, type) {
      this.title = '设置返佣比例'
      this.partnerDialogVisible = true
      this.upgradeRateForm = { ...row }
      this.input2 = BigNumber((row.rate * 10000) / 100).toNumber()
      this.btnType = type
      this.rebateType = row.rebateType
      this.rebateCycle = row.rebateCycle
      this.spotRateInput =
        row.spotRate !== undefined && row.spotRate !== null
          ? BigNumber((row.spotRate * 10000) / 100).toNumber()
          : ''
    },
    handlePsd(id) {
      const message = `确定重置 ${id} 的密码吗？`
      this.$confirm(message, '提示', { type: 'warning' }).then(() => {
        this.updatePsd({ userId: id }).then((res) => {
          if (res.code == 0) {
            this.$message.success('重置成功')
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg || '重置失败')
          }
        })
      })
    },
    handleLogin(row) {
      const message =
        row.type == 1
          ? `确定该顶级合伙人${row.channelUserId}禁止登录？`
          : `确定该顶级合伙人${row.channelUserId}允许登录？`

      this.$confirm(message, '提示', { type: 'warning' }).then(() => {
        this.forbidden({
          topChannelUserId: row.channelUserId,
          type: row.type,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.data)
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg)
          }
        })
      })
    },
    handleAddTopRemark(row) {
      this.remark = ''
      this.channelUserId = row.channelUserId
      this.centerDialogVisible = true
    },
    handleAddUser(row) {
      this.id = row.id
      this.setAddUser(true)
    },
    handleSort({ column, prop, order }) {
      this.setOrderBy(null)
      if (order) {
        const orderSort = order === 'descending' ? 'desc' : 'asc'
        this.setOrderBy(`${prop},${orderSort}`)
      }
      this.$emit('refresh')
    },
    openInviteWhitelist(row, isEdit) {
      if (!row.inviteCode) {
        this.$message.error('该合伙人无邀请码')
        return
      }
      this.inviteWhitelistRow = { ...row }
      this.inviteWhitelistEdit = isEdit
      this.inviteWhitelistVisible = true
      if (isEdit && row.inInviteChannelWhitelist) {
        this.wlContractPct =
          row.whitelistContractRate != null
            ? String(
              new BigNumber(row.whitelistContractRate).times(100).toNumber()
            )
            : ''
        this.wlSpotPct =
          row.whitelistSpotRate != null
            ? String(
              new BigNumber(row.whitelistSpotRate).times(100).toNumber()
            )
            : ''
      } else {
        this.wlContractPct = ''
        this.wlSpotPct = ''
      }
    },
    confirmInviteWhitelist() {
      const row = this.inviteWhitelistRow
      if (!row || row.tenantId === undefined || row.tenantId === null) {
        this.$message.error('缺少商户信息')
        return
      }
      const rDec = Number(this.wlContractPct) / 100
      const sDec = Number(this.wlSpotPct) / 100
      if (!(rDec > 0) || !(sDec > 0)) {
        this.$message.error('合约与现货返佣比例须均大于0')
        return
      }
      const maxR = Number(row.rate)
      const maxS = Number(row.spotRate)
      if (rDec > maxR || sDec > maxS) {
        this.$message.error('不能超过该合伙人当前合约/现货返佣比例')
        return
      }
      api
        .saveInviteWhitelist({
          tenantId: row.tenantId,
          channelUserId: row.channelUserId,
          inviteCode: row.inviteCode,
          rebateRate: rDec,
          spotRate: sDec,
        })
        .then((res) => {
          if (res.code === 0) {
            this.$message.success('保存成功')
            this.inviteWhitelistVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(
              res.msg || (res.error && res.error.msg) || '保存失败'
            )
          }
        })
    },
    handleRemoveInviteWhitelist() {
      const row = this.inviteWhitelistRow
      if (!row) return
      this.$confirm('确认从白名单中移除该合伙人？', '提示', {
        type: 'warning',
      }).then(() => {
        api
          .removeInviteWhitelist({
            tenantId: row.tenantId,
            channelUserId: row.channelUserId,
            inviteCode: row.inviteCode,
          })
          .then((res) => {
            if (res.code === 0) {
              this.$message.success('已移除')
              this.inviteWhitelistVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(
                res.msg || (res.error && res.error.msg) || '操作失败'
              )
            }
          })
      })
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(['userInfo']),
    ...mapState('partnerList', [
      'pagination',
      'userList',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
      'orderBy',
      'addUseVisible',
    ]),
    rebateCycleList() {
      switch (this.rebateType) {
        case 3:
          return [
            { label: '日返', value: 2 },
            // { label: '周返', value: 3 },
          ]
          break
        case 2:
          return [
            // { label: '实时返', value: 1 },
            { label: '日返', value: 2 },
            // { label: '周返', value: 3 },
          ]
          break

        default:
          return []
          break
      }
    },
  },
}
</script>
<style lang="less" src="../../../../styles/table.less" scoped></style>
<style lang="less" scoped>
.pag {
  display: flex;
  justify-content: center;
}

.user-type-select {
  width: 100%;
}

.red {
  color: skyblue;
  font-weight: bold;
}

.cc {
  color: #97a0ff;
  font-weight: bold;
}

::v-deep .el-dialog__title {
  color: #6767b3;
  font-size: 24px;
}

::v-deep.el-dialog__headerbtn {
  font-size: 26px;
}

::v-deep .el-dialog__body {
  display: flex;
  justify-content: center;

  .main {
    width: 100%;
    position: relative;

    .box-card {
      width: 100%;
      height: 260px;

      .el-card__body {
        height: 86%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .el-textarea {
          box-shadow:
            0px 0px 1px rgba(24, 26, 32, 0.1),
            0px 3px 6px rgba(71, 77, 87, 0.04),
            0px 1px 2px rgba(24, 26, 32, 0.04);
        }

        .el-textarea__inner {
          padding: 18px 16px;
        }

        .btn {
          display: flex;
          justify-content: center;

          .el-button--primary {
            width: 156px;
            height: 37px;
            background: #707aff;
            border-radius: 4px;
          }

          .el-button--default {
            width: 156px;
            height: 37px;
            background-color: #f5f6f9;
          }
        }
      }
    }

    .box-card1 {
      height: auto !important;

      .btn {
        padding-bottom: 10px;
      }

      .tip {
        text-align: center;
        color: #707aff;
      }
    }
  }
}

::v-deep .el-dialog--center {
  margin-top: 5vh;
  width: 468px;
  // height: 557px;
  background: #f5f6ff;
  border-radius: 8px;
}

::v-deep .invite-whitelist-dialog {
  width: 640px !important;
}

::v-deep .invite-whitelist-dialog .el-dialog__body {
  display: block;
}

::v-deep .invite-whitelist-form {
  width: 100%;
}

::v-deep .invite-whitelist-form .el-form-item__content {
  width: calc(100% - 150px);
}

::v-deep .invite-whitelist-form .el-input {
  width: 100%;
}

::v-deep.el-table th {
  font-weight: bold;
  color: #909399;
}
</style>
